var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.info)?_c('div',[_c('h1',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.product.info.name)+"\n    ")]),_vm._v(" "),(_vm.product.shortDescription)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.product.shortDescription)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }